<template>
  <figure v-on="$listeners" class="app-image" :class="size">
    <img class="app-image__image" :src="src" :alt="alt" />
  </figure>
</template>

<script>
export default {
  name: 'AppImage',

  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'thumbnail',
    },
  },
}
</script>

<style scoped>
.app-image.thumbnail {
  width: 150px;
  height: 150px;
  overflow: hidden;
}

.app-image.medium {
  width: 300px;
  height: 300px;
}

.app-image.large {
  width: 500px;
  height: 500px;
}

.app-image__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
}
</style>
